import React from "react";
import './starsComponent.css'

interface StrarsProperties {
    level:Number
}

export function StarsComponent(props:StrarsProperties) {

    function selected(index: number) {
        return index <= props.level ? ' Star-selected'  :''
    }

    function stars() {
        if(Array(props.level).length === 0) {
            return <p className="nostar">-</p>
        }
        return [...Array(props.level).keys()].map(r => <div key={r} className="Star-selected">★</div>);
    }

    return <div className="Stars">
        {
            stars()
        }
    </div>;

}

